module.exports = __webpack_public_path__ + "media/landing_page/hero-mobile-5f8bd5a0.jpg";